module.exports = __webpack_public_path__ + "img/predicciones_enviadas.f0753086.jpg";